export const metricFallsShortOfGoal = (target: number, projected: number): boolean =>
    target > 0 && projected < target;
